// extracted by mini-css-extract-plugin
export var createdDate = "_l0-1";
export var divider = "_l0-2";
export var headerDivider = "_l0-3";
export var messagesCard = "_l0-0";
export var messagesContainer = "_l0-7";
export var messagesContainerWrapper = "_l0-4";
export var pointerCapturingButtonBoxes = "_l0-a";
export var showLeftPanelButton = "_l0-9";
export var showMoreButton = "_l0-c";
export var showMoreButtonContainer = "_l0-b";
export var summaryTitle = "_l0-6";
export var systemMessageCardWrapper = "_l0-d";
export var topButtons = "_l0-8";
export var withPadding = "_l0-5";